import { useEffect, useState } from "react";

interface CountdownTimerProps {
  endDate: string;
  countdownType: "days" | "hours";
}

export function CountdownTimer({ endDate, countdownType }: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(endDate).getTime() - new Date().getTime();

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [endDate]);

  if (countdownType === "days") {
    return (
      <div className="flex gap-4 text-center">
        <div className="flex flex-col">
          <span className="text-3xl font-bold">{timeLeft.days}</span>
          <span className="text-sm text-muted-foreground">Days</span>
        </div>
        <div className="flex flex-col">
          <span className="text-3xl font-bold">{timeLeft.hours}</span>
          <span className="text-sm text-muted-foreground">Hours</span>
        </div>
        <div className="flex flex-col">
          <span className="text-3xl font-bold">{timeLeft.minutes}</span>
          <span className="text-sm text-muted-foreground">Minutes</span>
        </div>
        <div className="flex flex-col">
          <span className="text-3xl font-bold">{timeLeft.seconds}</span>
          <span className="text-sm text-muted-foreground">Seconds</span>
        </div>
      </div>
    );
  }

  // Hours countdown
  const totalHours = timeLeft.days * 24 + timeLeft.hours;
  return (
    <div className="flex gap-4 text-center">
      <div className="flex flex-col">
        <span className="text-3xl font-bold">{totalHours}</span>
        <span className="text-sm text-muted-foreground">Hours</span>
      </div>
      <div className="flex flex-col">
        <span className="text-3xl font-bold">{timeLeft.minutes}</span>
        <span className="text-sm text-muted-foreground">Minutes</span>
      </div>
      <div className="flex flex-col">
        <span className="text-3xl font-bold">{timeLeft.seconds}</span>
        <span className="text-sm text-muted-foreground">Seconds</span>
      </div>
    </div>
  );
}
